export const ApiUrls = {
  
  ADMIN_AUTH: {
    LOGIN: "/auth/login",
    REGISTER: "/auth/register",
  },
  ADMIN_APIS: {
    USERS: "/users",
    USER_DETAIL : "/auth/userDetail",
    USER_DELETE : "users",
    TASKS : "task/allTasks",
    ADD_TASK: "/task/addTask",
    ADMINS : "/auth/allsubadmins",
    ADD_SUBADMIN : "/auth/addSubadmin",
    IMPORT_USERS : "/file/upload",
    CATEGORIES:"/category",
    ADD_CATEGORY:"/category",
    DELETE_CATEGORY:"/category",
    EDIT_CATEGORY:"/category",
    DELETE_TASK:"/task/delete",
    DELETE_SUBADMIN:"/auth/deletesubadmin",
    EDIT_USER:"/users/update",
    ADD_QUESTION:"/questions",
    All_QUESTION:"/questions",
    DELETE_QUESTION:"/questions",
    TOGGLE_CATEGORY:"category/change-status",
    TOGGLE_USERS:"/users/change-status",
    GET_CATEGORY_BY_ID:"/questions/allquestion-by-category",
    EDIT_QUESTION:"/questions",
    GET_QUESTION_BY_ID:"/questions"
  },
};

export const servicesAccessibleWithoutToken = [
  ...Object.values(ApiUrls.ADMIN_AUTH),
//   ...Object.values(ApiUrls.CONFIG),
];
